<div class="login-container">
  <div class="card-login">
    <div class="header">
      <div class="logos">
          <img class="logo-gier" src="assets/svg/logoGier.svg" alt="">
      </div>
    </div>

    <div class="secao-bem-vindo">
      <h1 class="bem-vindo-titulo">SEJA BEM-VINDO</h1>
      <p class="access-instruction">PROCEDA SEU ACESSO POR USUÁRIO:</p>
      <p class="label-identificacao">IDENTIFICAÇÃO POR <span class="marcacao-usuario">USUÁRIO</span></p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form">      
      <div class="form-group">
        <input
          type="text"
          formControlName="usuario"
          placeholder="CPF ou Correio Eletrônico"
          class="form-input"
          [class.invalid]="loginForm.get('usuario')?.invalid && loginForm.get('usuario')?.touched"
        />
      </div>

      <div class="form-group">
        <div class="senha-container">
          <input
            [type]="mostrarSenha ? 'text' : 'password'"
            formControlName="senha"
            placeholder="Senha"
            class="form-input"
            [class.invalid]="loginForm.get('senha')?.invalid && loginForm.get('senha')?.touched"
          />
          <button
            type="button"
            class="senha-toggle"
            (click)="mudarVisibilidadeSenha()"
            [attr.aria-label]="mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'"
          >
            <mat-icon>{{ mostrarSenha ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
      </div>

      <div class="esqueceu-senha">
        <button type="button" class="esqueceu-senha-link" (click)="abrirEsqueciSenha()">
          Esqueceu a senha?
        </button>
      </div>

      <button type="submit" class="botao-login" [disabled]="loginForm.invalid">
        Acessar
      </button>
      <div class="login-error" *ngIf="erroLogin">
        Usuário ou senha inválidos.
      </div>
    </form>

    <div class="guia-rapido">
      <button type="button" class="guia-rapido-link" (click)="guiaRapidoAcesso()">
        Guia rápido de acesso
      </button>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>